import React from "react"
import { ColorModeContext, useMode } from "./theme/theme"
import { ThemeProvider } from "@emotion/react"
import { Box, Container, styled } from "@mui/material"
import NavBar from "./components/NavBar"
import { Outlet } from "react-router-dom"
import NavBarMob from "./components/NavBarMob"

const MainWrapperContainer = styled(Box)(({ theme }) => ({
	width: "100vw",
	height: "100vh",
	backgroundColor: theme.palette.background.default,
	margin: 0,
	padding: 0,
	overflow: "hidden",
	// color: theme.palette.text.secondary,
}))

export const PageContainerWrapper = styled(Container)(({ theme }) => ({
	marginTop: "10px",
}))

function App() {
	const [theme, colorMode] = useMode()
	return (
		<ColorModeContext.Provider value={colorMode}>
			<ThemeProvider theme={theme}>
				<MainWrapperContainer>
                    {window.innerWidth > 800 ?
                    <NavBar />
                    :
                    <NavBarMob/>
                }
					
					<Box
						sx={{
							height: window.innerHeight - 80,
							overflowY: "auto",
						}}
					>
						<Outlet />
					</Box>
				</MainWrapperContainer>
			</ThemeProvider>
		</ColorModeContext.Provider>
	)
}

export default App
